import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/fabrik.png";

function AppBar() {
  const clickhandler = (e) => {
    console.log(e);
  };
  return (
    <div>
      <nav className=" w-full font-Roboto ">
        <div className="max-w-full  px-4 ">
          <div className="flex flex-1 justify-between">
            <div className="flex flex-grow-1 space-x-7">
              <div>
                <Link to="/" className="flex items-center py-4 px-2">
                  {/* <svg
                    width="42"
                    height="53"
                    viewBox="0 0 42 53"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.0188 31.2696C41.0188 37.0055 38.8687 42.5064 35.0415 46.5623C31.2143 50.6182 26.0235 52.8968 20.611 52.8968C15.1985 52.8968 10.0077 50.6182 6.18044 46.5623C2.35323 42.5064 0.203125 37.0055 0.203125 31.2696C0.203125 25.8428 2.39475 19.5892 6.7181 12.6833C6.84708 12.4772 7.01314 12.3001 7.20678 12.1622C7.40042 12.0242 7.61784 11.928 7.84658 11.8792C8.07533 11.8304 8.31092 11.8299 8.53986 11.8776C8.7688 11.9254 8.9866 12.0206 9.1808 12.1577L16.3404 17.2161L23.1837 1.98629C23.3057 1.71457 23.4875 1.47786 23.7138 1.29605C23.9401 1.11424 24.2042 0.992635 24.4841 0.941456C24.7639 0.890277 25.0512 0.911019 25.3219 1.00194C25.5926 1.09286 25.8387 1.2513 26.0397 1.46395C29.3102 4.92384 33.0447 9.12093 35.945 14.0155C39.3589 19.7773 41.0188 25.4213 41.0188 31.2696Z"
                      fill="#00EDDF"
                    />
                    <path
                      d="M20.611 52.8984C26.0235 52.8984 31.2143 50.6198 35.0415 46.5639C30.8057 32.9473 26.7826 26.4718 16.3404 17.2177L9.1808 12.1592C8.9866 12.0221 8.7688 11.927 8.53986 11.8792C8.31092 11.8314 8.07533 11.8319 7.84658 11.8808C7.61784 11.9296 7.40042 12.0257 7.20678 12.1637C7.01314 12.3017 6.84708 12.4788 6.7181 12.6849C2.39475 19.5908 0.203125 25.8443 0.203125 31.2711C0.203125 37.007 2.35323 42.508 6.18044 46.5639C10.0077 50.6198 15.1985 52.8984 20.611 52.8984Z"
                      fill="#2A91D7"
                    />
                  </svg> */}
                  <img src={logo} width="39" height="45" />
                  <span className="font-extrabold text-blue-200 text-3xl px-1">
                    Fabrik
                  </span>
                </Link>
              </div>
            </div>

            <div className=" md:flex items-center  ">
              <div className=" md:flex items-center  gap-3 shrink">
                <Link to="/tour" className="link-blue ">
                  Tour
                </Link>
                <Link to="/pricing" className="link-blue">
                  Pricing
                </Link>
                <Link to="/learn" className="link-blue">
                  Learn
                </Link>
                <Link
                  to="/login"
                  className="py-2 px-4 font-medium text-blue-200 rounded hover:bg-blue-100 hover:text-white "
                >
                  Log In
                </Link>
                <Link
                  to="/register"
                  className="py-2 px-4 font-medium text-white bg-blue-200 rounded hover:bg-blue-100 "
                >
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default AppBar;
